// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2888":"878e6ede90a02cfb","5405":"f0458e9d0178f149","5977":"f0458e9d0178f149"}[chunkId] + ".css";
};